<script>
import * as sdk from '../../functions/sdk';
import { store } from '../../functions/mixins';
import UiContainer from '../ui/Container';
import UiHeadline from '../ui/Headline';
import UiSubheader from '../ui/Subheader';
import UiLoading from '../ui/Loading';
import UiButton from '../ui/Button';
import UiInput from '../ui/Input';
import { openPopup, dispatch } from '../../functions/crossPopup';

export default {
    mixins: [store],
    components: {
        UiContainer,
        UiHeadline,
        UiSubheader,
        UiLoading,
        UiButton,
        UiInput,
    },
    data: () => ({
        imageUrl: null,
    }),
    methods: {
        openStudio() {
           this.imageUrl = null;
           openPopup('https://studio.ntatic.now.sh/index.html', (type, payload, ID) => {
               switch (type) {
                   case 'IMAGE_UPLOAD':
                       sdk.imageService.upload(new Blob(payload.parts, payload.options)).then(image => {
                            dispatch(ID, 'IMAGE_UPLOAD_DONE', {
                                success: true,
                                url: image.imageUrl,
                            });
                            this.imageUrl = image.imageUrl;
                       }).catch(() => {
                           dispatch(ID, '_DONE', {
                                success: false,
                                url: false,
                            });
                       });
                       break;
               }
           }, 'Studio');
       },
    },
}
</script>

<template>
    <ui-container>
        <ui-button @click.native="openStudio()">Test studio</ui-button>
        <img :src="imageUrl" v-if="imageUrl" :style="{maxWidth: '100%', margin: '20px 0'}" />
    </ui-container>
</template>

<style lang="stylus">
@import '../../stylus/vars.styl'
</style>

